import {
  Component,
  ChangeDetectionStrategy,
  input,
  output,
  model,
  computed,
} from '@angular/core';
import { SvgViewboxDirective } from '@exl-ng/mulo-core';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';

type ButtonState = 'open' | 'closed';

@Component({
  selector: 'mulo-menu-toggle-button',
  templateUrl: './menu-toggle-button.component.html',
  styleUrls: ['./menu-toggle-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'mulo-menu-toggle-button' },
  imports: [MatIconButton, MatIcon, SvgViewboxDirective],
})
export class MenuToggleButtonComponent {
  readonly state = model<ButtonState>('closed');
  readonly openIcon = input('menu');
  readonly closeIcon = input('menu-open');
  readonly openText = input<string | null>('Open Menu');
  readonly closeText = input<string | null>('Close Menu');

  readonly isClosed = computed(() => this.state() === 'closed');
  readonly clicked = output<ButtonState>();

  onClick() {
    this.clicked.emit(this.state());
  }

  public toggleState() {
    this.state.update((prev) => (prev === 'open' ? 'closed' : 'open'));
  }
}
